import { StyleSheet } from 'react-native';
import type { AppTheme } from '../../theme';
export const makeStyles = (theme: AppTheme) => StyleSheet.create({
  wrap: { paddingVertical: theme.spacing.sm, gap: theme.spacing.sm },
  hint: { color: theme.colors.muted, fontSize: theme.font.size.sm, lineHeight: 20 },
  text: { color: theme.colors.text, fontSize: theme.font.sizePx.px14, fontWeight: theme.font.weight.semibold },
  choice: { minHeight: 44, justifyContent: 'center', borderColor: theme.colors.border, borderWidth: 1, borderRadius: theme.radius.md, padding: theme.spacing.sm },
  consent: { flexDirection: 'row', gap: theme.spacing.sm, alignItems: 'flex-start', minHeight: 44, paddingVertical: theme.spacing.xs },
  checkbox: { width: 20, height: 20, borderRadius: theme.radiusPx.px2, borderWidth: 1, borderColor: theme.colors.muted, alignItems: 'center', justifyContent: 'center' },
  checked: { backgroundColor: theme.colors.primary, borderColor: theme.colors.primary },
  disabled: { opacity: 0.45 },
  consentText: { color: theme.colors.text, fontSize: theme.font.sizePx.px14, lineHeight: 21, flex: 1 },
});
